export default __webpack_public_path__ + "static/media/02.c66b5270.jpg";